import styled from 'styled-components';
import Card from './ui/Card';
import ValueSlider from './ui/ValueSlider';
import { GoldButton } from './ui/Buttons';
import { ui } from './ui/tokens';

export const PENCIL_MIN = 1;
export const PENCIL_MAX = 10;

// Quick picks shown as pixel glyphs (style guide R14 step 7)
const PRESETS = [
	{ width: 1, height: 1 },
	{ width: 2, height: 2 },
	{ width: 1, height: 2 },
	{ width: 2, height: 1 },
	{ width: 5, height: 5 },
];

export type PencilSizeCardProps = {
	open: boolean;
	width: number;
	height: number;
	onChange: (width: number, height: number) => void;
	onClose: () => void;
	/** Wizard position when shown as the last setup step */
	step?: number;
	totalSteps?: number;
};

function PencilSizeCard({ open, width, height, onChange, onClose, step, totalSteps }: PencilSizeCardProps) {
	return (
		<Card open={open} title="Pencil size" step={step} totalSteps={totalSteps} onClose={step ? undefined : onClose}>
			<Presets>
				{PRESETS.map(p => {
					const selected = p.width === width && p.height === height;
					return (
						<Preset key={`${p.width}x${p.height}`} type="button" $selected={selected} onClick={() => onChange(p.width, p.height)} aria-label={`${p.width} by ${p.height}`} aria-pressed={selected}>
							<Glyph $w={p.width} $h={p.height}>
								{Array.from({ length: p.width * p.height }).map((_, i) => (
									<Cell key={i} />
								))}
							</Glyph>
						</Preset>
					);
				})}
			</Presets>

			<ValueSlider label="Width" value={width} min={PENCIL_MIN} max={PENCIL_MAX} onChange={w => onChange(w, height)} />
			<ValueSlider label="Height" value={height} min={PENCIL_MIN} max={PENCIL_MAX} onChange={h => onChange(width, h)} />

			<GoldButton type="button" onClick={onClose} style={{ width: '100%', marginTop: 24 }}>
				Start drawing
			</GoldButton>
		</Card>
	);
}

export default PencilSizeCard;

const Presets = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 14px;
	margin: 22px 0 6px;
`;

const Preset = styled.button<{ $selected: boolean }>`
	min-width: 38px;
	min-height: 38px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: transparent;
	border: 2px solid ${props => (props.$selected ? ui.text : 'transparent')};
	border-radius: 4px;
	padding: 4px;
	cursor: pointer;
`;

const Glyph = styled.div<{ $w: number; $h: number }>`
	display: grid;
	grid-template-columns: repeat(${props => props.$w}, 5px);
	grid-template-rows: repeat(${props => props.$h}, 5px);
	gap: 1px;
`;

const Cell = styled.div`
	width: 5px;
	height: 5px;
	background-color: ${ui.text};
`;
